import React from 'react'
import providerConfig from '../config'
/**
 * UploadProviderLoaders component for loading upload provider scripts
 *
 * A functional component that dynamically loads all configured upload provider
 * loaders (e.g., Google Drive, Dropbox, etc.) based on the provider configuration.
 * Each provider can include initialization scripts or SDK loaders.
 *
 * @returns JSX element containing all configured provider loaders
 */
export const UploadProviderLoaders = (): React.ReactNode => {
  return (
    <>
      {Object.keys(providerConfig).map(key => {
        const Loader = providerConfig[key]?.loader
        if (Loader) return <Loader key={key} />
        return null
      })}
    </>
  )
}
